// extracted by mini-css-extract-plugin
export default {"dataSheetFormSectionWrap":"CCModalInternalSaveSearch_dataSheetFormSectionWrap__SKxAt"};